import type { CostsStats } from '../../types/costs';

export const formatMoney = (v?: number) => {
    const n = Number(v ?? 0);

    return n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: Math.abs(n) < 1 ? 6 : 2,
    });
};

export const resolveMetricKey = (dateType?: 'week' | 'month' | 'day') => ((dateType === 'week' || dateType === 'month' || dateType === 'day') ? dateType : 'history');

export const getMetric = (block: { day?: number; week?: number; month?: number; history?: number } | undefined, key: 'day' | 'week' | 'month' | 'history') =>
    Number(block?.[key] || 0);

export const safeStats = (s?: CostsStats): CostsStats => ({
    getStarted: s?.getStarted || {},
    scenarioChat: s?.scenarioChat || {},
    runs: s?.runs || {},
    propertyRuns: s?.propertyRuns || {},
    scenarioRuns: s?.scenarioRuns || {},
    chat: s?.chat || {},
    total: s?.total || {},
});